import { useHookstate } from "@hookstate/core";
import { FormControlLabel, Checkbox } from "@mui/material";
import {
  MESSAGE_FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { StyledCheckbox } from "./CheckboxStyled";
import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useEffect } from "react";
import { CheckIcon, UncheckIcon } from "assets/svgIcons";
import { useTranslation } from "react-i18next";

export const ForwardMessageCheckbox = ({ identification, disableState }) => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();

  const { siteSettingsData } = useSelector((state) => state.commonReducers);
  const { forwardMessageGlobalState } = useHookstate(
    MESSAGE_FLEET_GLOBAL_STATES
  );

  useEffect(() => {
    if (siteSettingsData) {
      forwardMessageGlobalState.set(siteSettingsData.ForwardMessages);
    }
  }, [siteSettingsData]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  const handleCheckboxValue = (e, identification) => {
    if (identification === "FM") {
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices2({
          value: e.target.checked,
          code: identification,
        },siteId.get())
      ).then(() => {
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      });

      forwardMessageGlobalState.set(e.target.checked);
    }
  };

  //       ######################################################################################################################################    //
  return (
    <StyledCheckbox className="checkbox">
      <FormControlLabel
        control={
          <Checkbox
            disabled={disableState}
            icon={<UncheckIcon width={20} height={20} />}
            checkedIcon={<CheckIcon width={20} height={20} />}
            checked={forwardMessageGlobalState.get()}
            onChange={(e) => handleCheckboxValue(e, identification)}
          />
        }
        label={t("Forward_messages_to_marshals")}
      />
    </StyledCheckbox>
  );
};
